import { useCallback, useEffect, useState } from 'react'
import { usePageAccess } from '@/hooks/usePageAccess'
import { listPurchasingPackValues } from '@/services/purchasing'
import type { PurchasingPackValueRow } from '@/services/purchasingTypes'
import PurchasingPackValuesList from '@/pages/purchasing/PurchasingPackValuesList'
import { formatApiError } from '@/utils/apiError'
import { toast } from '@/store/toastStore'

export default function PurchasingSettings() {
  const { canEdit } = usePageAccess('purchasing')
  const [values, setValues] = useState<PurchasingPackValueRow[]>([])
  const [loading, setLoading] = useState(true)

  const loadValues = useCallback(async () => {
    setLoading(true)
    try {
      const res = await listPurchasingPackValues({ limit: 1000 })
      setValues(res.values)
    } catch (err) {
      toast.error(formatApiError(err, 'Failed to load pack values'))
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    void loadValues()
  }, [loadValues])

  return (
    <div className="flex h-full min-h-0 flex-col gap-4">
      <div className="min-h-0 w-[400px] flex-1">
        <PurchasingPackValuesList
          values={values}
          loading={loading}
          canEdit={canEdit}
          onRefresh={loadValues}
        />
      </div>
    </div>
  )
}
